import React from "react";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const DateInput = ({ label, value, onChange }) => {
  const handleChange = (e) => {
    const newVal = e.target.value ? dayjs(e.target.value).toDate() : null;
    onChange(newVal);
  };

  return (
    <TextField
      type="date"
      label={label}
      value={value ? dayjs(value).format("YYYY-MM-DD") : ""}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
      fullWidth
      sx={{
        minWidth: 180,
        "& input": {
          fontWeight: 500,
          py: 1.5,
          borderRadius: "12px",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          bgcolor: "#fafafa",
        },
      }}
    />
  );
};

export default DateInput;
